import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Crown, Check, Loader2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const BENEFITS = [
  "Générations illimitées (1, 5, 10 grilles instantanées)",
  "Toutes les stratégies : Équilibré, Écarts/Retards, Anti-partage",
  "Analyseur de grille illimité sur les 4 loteries",
  "Export CSV & impression prêts pour le buraliste",
  "Alertes de retards statistiques exclusives",
];

export const PremiumDialog = ({ open, onOpenChange }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);

  const checkout = async () => {
    if (!user) {
      toast.error("Connectez-vous pour souscrire");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg rounded-3xl overflow-hidden p-0" data-testid="stripe-checkout-modal">
        <div className="bg-gradient-to-br from-[#0B132B] via-[#003B80] to-[#0052CC] p-8 text-white relative">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: "url(https://images.unsplash.com/photo-1669951584605-4deba095a87f?crop=entropy&cs=srgb&fm=jpg&q=60&w=800)", backgroundSize: "cover" }} />
          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-[#FFB800] text-[#0B132B] font-black text-xs uppercase tracking-wider px-3 py-1.5 rounded-full mb-4">
              <Crown className="w-4 h-4" /> Premium
            </div>
            <DialogHeader>
              <DialogTitle className="text-3xl font-black text-white">Passez en illimité</DialogTitle>
              <DialogDescription className="sr-only">Abonnement Premium ProbaLoto à 9,99€ par mois</DialogDescription>
            </DialogHeader>
            <div className="mt-3 flex items-end gap-2">
              <span className="text-5xl font-black">9,99 €</span>
              <span className="text-white/70 mb-1.5 font-bold">/ mois · sans engagement</span>
            </div>
          </div>
        </div>
        <div className="p-8 space-y-3">
          {BENEFITS.map((b) => (
            <div key={b} className="flex items-start gap-3">
              <span className="mt-0.5 w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                <Check className="w-3.5 h-3.5 text-emerald-600" />
              </span>
              <span className="text-slate-700 text-sm">{b}</span>
            </div>
          ))}
          <Button onClick={checkout} disabled={busy}
            className="w-full mt-4 rounded-full h-12 font-black text-[#0B132B] bg-[#FFB800] hover:bg-[#EAB308] hover:scale-[1.02] transition-all text-base"
            data-testid="stripe-pay-button">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "S'abonner avec Stripe"}
          </Button>
          <p className="text-center text-xs text-slate-400">Paiement sécurisé par Stripe · Carte test 4242 4242 4242 4242</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
